import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './site-settings.reducer';

export const SiteSettingsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const siteSettingsEntity = useAppSelector(state => state.siteSettings.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="siteSettingsDetailsHeading">
          <Translate contentKey="activitiesApp.siteSettings.detail.title">SiteSettings</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{siteSettingsEntity.id}</dd>
          <dt>
            <span id="settingKey">
              <Translate contentKey="activitiesApp.siteSettings.settingKey">Setting Key</Translate>
            </span>
          </dt>
          <dd>{siteSettingsEntity.settingKey}</dd>
          <dt>
            <span id="settingValue">
              <Translate contentKey="activitiesApp.siteSettings.settingValue">Setting Value</Translate>
            </span>
          </dt>
          <dd>{siteSettingsEntity.settingValue}</dd>
        </dl>
        <Button tag={Link} to="/site-settings" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/site-settings/${siteSettingsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SiteSettingsDetail;
